import { render, staticRenderFns } from "./TaskReport.vue?vue&type=template&id=58deefdb&scoped=true&"
import script from "./TaskReport.vue?vue&type=script&lang=js&"
export * from "./TaskReport.vue?vue&type=script&lang=js&"
import style0 from "./TaskReport.vue?vue&type=style&index=0&id=58deefdb&scoped=true&lang=css&"
import style1 from "./TaskReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58deefdb",
  null
  
)

export default component.exports